export default "__VITE_ASSET__BkdFGU2y__"